import styled from 'styled-components';

interface IPropsFormWrapper {
  error?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  height: fit-content;

  padding: 24px;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
`;

export const Card = styled.div`
  width: 100%;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 2px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14);
  background-color: ${({ theme }) => theme.colors.white};

  h2 {
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray[600]};
  }
`;

export const FormWrapper = styled.div<IPropsFormWrapper>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: ${(props) => (props.error ? '25px' : '16px')};

  label {
    flex: 1;
    position: relative;
    min-width: 264px;

    input {
      width: 100%;
      font-size: 14px;
      font-weight: 400;

      &::placeholder {
        color: #a6a6a6;
      }
    }
  }
`;
